import { BoxProps, Popover, Portal } from "@chakra-ui/react";
import { ReactNode } from "react";

export const CustomPopover = ({
  children,
  trigger,
  onClose,
  onOpen,
  initialFocusEl,
  open,
  ...props
}: {
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  initialFocusEl?: () => HTMLElement | null;
  children: ReactNode;
  trigger: ReactNode;
} & BoxProps) => {
  return (
    <Popover.Root
      lazyMount
      unmountOnExit
      initialFocusEl={initialFocusEl}
      open={open}
      onOpenChange={({ open }) => {
        if (open) {
          onOpen?.();
        } else {
          onClose?.();
        }
      }}
    >
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content {...props}>
            <Popover.Arrow />
            <Popover.CloseTrigger />
            {children}
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
